import React from 'react';
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import TrackingResults from '../../components/TrackingResults/TrackingResults';

const manageTrackingResults = () => (
  <div className="wrapper">
    <Breadcrumbs/>
    <TrackingResults/>
  </div>
);

export default manageTrackingResults;



// WEBPACK FOOTER //
// ./src/pages/manage/ManageTrackingResults.js